/**
 * Perform actions related to the different world zones.
 *
 * @type {Object}
 */
Game.Utils.MapZones = {


	/**
	 * Check to see if the Skier is in an actionable zone and then perform
	 * appropriately.
	 *
	 * @param  {skier} skier The skier to check.
	 */
	check: function( skier ) {

		// Loop through all zones.
		for ( var key in Game.Utils.Map.zones ) {

			if ( ! Game.Utils.Map.zones.hasOwnProperty( key ) ) {
				continue;
			}

			// Store the current zone. Mostly for readability.
			var zone = Game.Utils.Map.zones[ key ];

			// If the skier is in the current zone then do something.
			if ( this.in_zone( skier, zone ) ) {

				// Check to see if the current zone type has an action, and if
				// so run the action.
				if ( 'function' === typeof Game.Utils.MapZonesActions[ zone.type ] ) {

					Game.Utils.MapZonesActions[ zone.type ]( skier, zone );

				}

			}

		}

	},


	/**
	 * Check if a skier is in a zone.
	 *
	 * @param  {Object} skier The skier to test against the zone.
	 * @param  {Object} zone  The zone to check against.
	 * @return {boolean}
	 */
	in_zone: function( skier, zone ) {

		// Ensure a zone is being passed in.
		if ( ! zone ) {
			return false;
		}

		// Offset the skier y position since by default it sits below the player
		// graphic.
		var y = skier.y - 4;
		var x = skier.x;

		if ( y > zone.y ) {
			if ( y < zone.y + zone.height ) {
				if ( x > zone.x ) {
					if ( x < zone.x + zone.width ) {

						return true;

					}
				}
			}
		}

		return false;

	}

};
